import { render, staticRenderFns } from "./SalePrintExtraOptionsModal.vue?vue&type=template&id=28f485ec&scoped=true"
import script from "./SalePrintExtraOptionsModal.vue?vue&type=script&lang=ts"
export * from "./SalePrintExtraOptionsModal.vue?vue&type=script&lang=ts"
import style0 from "./SalePrintExtraOptionsModal.vue?vue&type=style&index=0&id=28f485ec&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f485ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28f485ec')) {
      api.createRecord('28f485ec', component.options)
    } else {
      api.reload('28f485ec', component.options)
    }
    module.hot.accept("./SalePrintExtraOptionsModal.vue?vue&type=template&id=28f485ec&scoped=true", function () {
      api.rerender('28f485ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SalePrintExtraOptionsModal.vue"
export default component.exports